import { cssVariables } from "@/utils/utils";
import { Button, Flex } from "antd";
import { useTranslation } from "react-i18next";
import AntIcon from "../../../../../../common/components/icons/AntIcon";
import Ellipsis from "../../../../../../common/components/views/Ellipsis";
import { CommissionsSettingsLevelBase } from "../../../../../commissions/level/types";
import { formatCommissionsLevelName } from "../../../../../commissions/level/utils";
import styles from "../../statistics/DashboardStatisticsWidget.module.scss";
import { StatNumber } from "./common/StatNumber";
import { STATS_HEIGHT } from "./common/utils";

type Props = {
  data: { currentLevel: CommissionsSettingsLevelBase; nextLevelPoints: number };
};

export const LevelData = ({ data }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Flex align="center">
        <Button className={styles.labelIcon} variant="filled" color="orange" icon={<AntIcon type="trophy" />} />

        <Ellipsis style={{ flex: 1 }}>
          <span style={{ fontSize: 21, paddingLeft: 8 }}>
            {t("dashboard.statisticsExtended.level")} {formatCommissionsLevelName(data.currentLevel)}
          </span>
        </Ellipsis>
      </Flex>

      <Flex justify="center" align="center" className="margin-top-tiny" style={{ height: STATS_HEIGHT }}>
        <Flex align="end">
          <StatNumber value={data.nextLevelPoints} />

          <span style={{ paddingLeft: 8, lineHeight: "34px" }}>{t("dashboard.statisticsExtended.helpers.points")}</span>
        </Flex>
      </Flex>

      <Ellipsis style={{ color: cssVariables.colorGrey, textAlign: "center" }}>
        {t("dashboard.statisticsExtended.helpers.toNextLevel")}
      </Ellipsis>
    </>
  );
};
